import styled from 'styled-components';
import { getMediaQuery, themeGet } from '@magalu/stereo-ui-styles';
import Flex from '../../atoms/Flex';
export const Container = styled(Flex).attrs(() => ({
  flexDirection: ['column', 'row', 'row'],
  justifyContent: 'space-evenly',
  left: 0,
  lineHeight: 'big',
  padding: 3,
  position: 'fixed',
  top: ['0', 'inherit', 'inherit'],
  width: '100%',
  zIndex: 3
}))`
  background-color: ${props => themeGet('baseColors.overlay.dark')(props)};
  ${getMediaQuery('small')} {
    bottom: 0;
    max-height: 100px;
  }
`;